import { toast } from 'react-toastify';
import apiCall from "../../utils/apiCall";

/* ---------------------------
   TaskGroup API Actions
----------------------------*/

// Get all TaskGroups.
export const getTaskGroups = (dispatch) => async () => {
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall('/taskgroups', 'GET', null);
    dispatch({ type: 'GET_TASK_GROUPS', payload: data });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    dispatch({ type: "SET_LOADING", payload: false });
  }
};

// Add a new TaskGroup.
export const addTaskGroup = (dispatch) => async (taskGroup) => {
  const toastId = toast.loading("Adding Task Group...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall('/taskgroups', 'POST', taskGroup);
    dispatch({ type: 'ADD_TASK_GROUP', payload: data });
    toast.update(toastId, {
      render: "Task group added successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error adding task group: ${error.message}`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Add TaskGroup Error:', error);
  }
};

// Edit an existing TaskGroup.
export const editTaskGroup = (dispatch) => async (taskGroup) => {
  const toastId = toast.loading("Updating Task Group...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall(`/taskgroups/${taskGroup._id}`, 'PUT', taskGroup);
    dispatch({ type: 'EDIT_TASK_GROUP', payload: data });
    toast.update(toastId, {
      render: "Task group updated successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error updating task group: ${error.message}`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Edit TaskGroup Error:', error);
  }
};

// Delete a TaskGroup.
export const deleteTaskGroup = (dispatch) => async (taskGroupId) => {
  const toastId = toast.loading("Deleting Task Group...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    await apiCall(`/taskgroups/${taskGroupId}`, 'DELETE', null);
    dispatch({ type: 'DELETE_TASK_GROUP', payload: taskGroupId });
    toast.update(toastId, {
      render: "Task group deleted successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error deleting task group: ${error.message}`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Delete TaskGroup Error:', error);
  }
};

/* ---------------------------
   Task API Actions
----------------------------*/

// Get all Tasks.
export const getTasks = (dispatch) => async () => {
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall('/tasks', 'GET', null);
    dispatch({ type: 'GET_TASKS', payload: data });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    dispatch({ type: "SET_LOADING", payload: false });
  }
};

// Add a new Task.
export const addTask = (dispatch) => async (task) => {
  const toastId = toast.loading("Adding Task...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall('/tasks', 'POST', task);
    dispatch({ type: 'ADD_TASK', payload: data });
    toast.update(toastId, {
      render: "Task added successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error adding task: ${error.message}`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Add Task Error:', error);
  }
};

// Edit an existing Task.
export const editTask = (dispatch) => async (task) => {
  const toastId = toast.loading("Updating Task...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    const data = await apiCall(`/tasks/${task._id}`, 'PUT', task);
    dispatch({ type: 'EDIT_TASK', payload: data });
    toast.update(toastId, {
      render: "Task updated successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error updating task: ${error.message}`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Edit Task Error:', error);
  }
};

// Delete a Task.
export const deleteTask = (dispatch) => async (taskId) => {
  const toastId = toast.loading("Deleting Task...");
  try {
    dispatch({ type: "SET_LOADING", payload: true });
    await apiCall(`/tasks/${taskId}`, 'DELETE', null);
    dispatch({ type: 'DELETE_TASK', payload: taskId });
    toast.update(toastId, {
      render: "Task deleted successfully!",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
  } catch (error) {
    dispatch({ type: "SET_ERROR", payload: error.message });
    toast.update(toastId, {
      render: `Error deleting task: ${error.message}`,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    dispatch({ type: "SET_LOADING", payload: false });
    console.error('Delete Task Error:', error);
  }
};
